import React, { useContext } from 'react';
import theme from '../theme/theme';
import { getPredictionDetails } from '../utils'
import { Box, useMediaQuery } from '@mui/material';
import { globalStore } from '../state/store';
import { CORRECTRESULTSCORES, CORRECTRESULT } from '../assets/configs/constants';

const DisplayMatchScore = ({matchid, variant}) => {

  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdUp = useMediaQuery(theme.breakpoints.up('lg'));
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const [state, dispatch] = useContext(globalStore);

  return (
    <Box sx={{ textAlign:'center'}}>
    {//variant === 'dashboard' &&
    getPredictionDetails(state, matchid).home !== undefined && getPredictionDetails(state, matchid).home !== null && getPredictionDetails(state, matchid).home !== '' && 
    getPredictionDetails(state, matchid).away !== undefined && getPredictionDetails(state, matchid).away !== null && getPredictionDetails(state, matchid).away !== '' ?
    <span style={{
        backgroundColor: 
            !isNaN(getPredictionDetails(state, matchid).pts) && 
            getPredictionDetails(state, matchid).pts === CORRECTRESULTSCORES ?
              theme.palette.success.main : 
            !isNaN(getPredictionDetails(state, matchid).pts) && 
            getPredictionDetails(state, matchid).pts === CORRECTRESULT ?
              theme.palette.primary.main :
            !isNaN(getPredictionDetails(state, matchid).pts) && 
            getPredictionDetails(state, matchid).pts === 0 ?
              theme.palette.error.main :
              theme.palette.grey[800], 
        color: theme.palette.primary.contrastText, 
        borderRadius: '30px', 
        padding: isLgUp ? '4px 13px' : '3px 10px',
        fontSize: isSmUp && variant === "predict" ? '15px' : isLgUp ? '14px' : isSmUp ? '13px' : '12px', 
        fontWeight: isLgUp || variant === "predict" ? '500' : '400'}}>
        {getPredictionDetails(state, matchid).home} - {getPredictionDetails(state, matchid).away}
    </span>
    /*:
    variant === 'dashboard' ? 
        "-"
    :home !== undefined && home !== null && home !== '' && 
    away !== undefined && away !== null && away !== '' ?

            <span style={{backgroundColor: theme.palette.grey[800], 
            color: theme.palette.primary.contrastText, 
            borderRadius: '30px', padding: isSmUp ? '5px 15px' : '3px 8px', 
            fontSize: isSmUp ? '15px' : '13px', 
            fontWeight: '500'}}>
                {home} - {away}
            </span>*/
    : "-"}
    </Box>
  );
};
export default DisplayMatchScore;